import {
    lazyGetServerOptionsForFeature,
    OwsOptionsFeatureType,
    ProofingOptions,
    ComposeAssistanceOptions,
} from 'owa-outlook-service-options';
import { updateUserOptions } from '../actions/updateUserOptions';
import { getCurrentCulture } from 'owa-localize';
import deserializeOverriddenOptions from '../utils/deserializeOverriddenOptions';

export default async function fetchUserOptionsFromService(): Promise<void> {
    const getServerOptionsForFeature = await lazyGetServerOptionsForFeature.import();
    const proofingOptions = await getServerOptionsForFeature<ProofingOptions>(
        OwsOptionsFeatureType.Proofing
    );

    const composeAssistanceOptions = await getServerOptionsForFeature<ComposeAssistanceOptions>(
        OwsOptionsFeatureType.ComposeAssistance
    );

    const { overriddenOptions, overriddenCategories } = deserializeOverriddenOptions(
        proofingOptions?.overriddenOptions
    );
    updateUserOptions({
        overriddenOptions: overriddenOptions,
        overriddenCategories: overriddenCategories,
        spellCheckEnabled: proofingOptions.spellCheckEnabled,
        grammarEnabled: proofingOptions.grammarEnabled,
        writingRefinementsEnabled: getWritingRefinementsEnabled(proofingOptions),
        proofingLocale: getProofingLocaleOrDefault(proofingOptions),
        textPredictionEnabled: composeAssistanceOptions.composeAssistanceEnabled,
        finalDatePremiumDemo: proofingOptions.finalDatePremiumDemo,
        premiumSuggestionsCount: proofingOptions.premiumSuggestionsCount,
        startDatePremiumPreview: proofingOptions.startDatePremiumPreview,
        weekCounter: proofingOptions.weekCounter,
    });
}

// For first time users the proofingLocale is undefined.
// when getCurrentCulture() is not supported within Proofin the service will fail- BUG 34859
function getProofingLocaleOrDefault(proofingOptions: ProofingOptions): string | undefined {
    return proofingOptions.proofingLocale || getCurrentCulture();
}

function getWritingRefinementsEnabled(proofingOptions: ProofingOptions): boolean {
    // Since we're using the new settings dialog, check all of the individual refinement types.

    // TODO: check the status of the individual refinements and return true iff none of the refinements are disabled
    // WI: 81669
    return true;
}
